<template>
  <start-screen v-if="current_view==='start'" @showGame="showView('game')" @showLeaderboard="showView('leaderboard')"></start-screen>
  <game v-if="current_view==='game'" @showStart="showView('start')" @showEnd="showView('end')"></game>
  <leaderboard v-if="current_view==='leaderboard'"></leaderboard>
  <end-screen v-if="current_view==='end'" @showStart="showView('start')" ></end-screen>
</template>

<script>

import StartScreen from "@/components/start";
import Game from "@/components/game";
import EndScreen from "@/components/end";
import Leaderboard from "@/components/leaderboard";
export default {
  name: 'App',
  components: {Leaderboard, EndScreen, Game, StartScreen},
  data(){
    return {
      current_view: "start"
    }
  },
  methods: {
    showView(view){
      this.current_view = view;
    }
  }
}
</script>

<style>
body, html, #app{
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: sans-serif;
  overflow: hidden;
}
</style>
